import AdminStatsManager from '../components/AdminStatsManager';
import PageLayout from '../components/pageLayout';

function AdminStatsManagerPage() {
    return (
        <PageLayout children={<AdminStatsManager/>} />
    );
}

export default AdminStatsManagerPage;
